import SiafLiteApiRepository from "../../external/siafLiteApi";

class ManifestacaoDestinatarioService {
  constructor() {
    this.urlBase = "/estoque/manifestos-destinatario";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  consultarManifestacao(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  getArquivoDanfe(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/danfe`).patch(body);
  }

  registrarEvento(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/eventos`).patch(body);
  }
} 

export default ManifestacaoDestinatarioService;
